import { Preview } from './CardPreview.styled'

export type CardPreviewProps = {
  url?: string
  defaultUrl?: string
}

const CardPreview: React.FC<CardPreviewProps> = ({ url, defaultUrl }) => {
  return <Preview url={url} defaultUrl={defaultUrl} data-test='CardPreview' />
}

export default CardPreview
